export default __webpack_public_path__ + "static/christopher-gower-m_HRfLhgABo-unsplash-84a0f7da866bc9d3a9f2fcb69b642d62.jpg";